import { ASSETS } from "@/lib/constants";

/**
 * Small trophy mark used inline to the left of card headings and segment headings.
 * Decorative — hidden from assistive tech.
 */
export default function CardMark({ className = "" }) {
  return (
    <img
      src={ASSETS.trophyMark}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className={`h-10 sm:h-12 w-auto object-contain shrink-0 [filter:drop-shadow(0_2px_10px_rgba(214,163,41,0.35))] ${className}`}
    />
  );
}
